import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const requiredRoles = [];
    const path = route.url[0]?.path;

    switch (path) {
      case 'aide':
        return true;
      case '':
      case undefined:
        requiredRoles.push('pfa.visualiser-accueil', 'pfa-gpo.visualiser-accueil');
        break;
      case 'cockpit':
        const userRoles: string[] = this.keycloak.getUserRoles();
        if (
          !userRoles.includes('pfa.piloter-cockpit') &&
          !userRoles.includes('pfa-opt.piloter-cockpit') &&
          !userRoles.includes('pfa-gpo.piloter-cockpit')
        ) {
          return this.router.parseUrl('/forbidden');
        }
        requiredRoles.push(
          'pfa.piloter-cockpit',
          'pfa-gpo.piloter-cockpit',
          'pfa-opt.piloter-cockpit',
        );
        break;
      case 'cockpit/optique':
        requiredRoles.push('pfa-opt.piloter-cockpit');
        break;
      case 'marge':
        requiredRoles.push('pfa.piloter-marge');
        break;
      case 'rentabilitelineaire':
        requiredRoles.push('pfa.piloter-rentabilite-lineaire');
        break;
      case 'ventes':
        requiredRoles.push('pfa.piloter-ventes');
        break;
      case 'stock':
        requiredRoles.push('pfa.piloter-stocks');
        break;
      case 'ranking':
        requiredRoles.push('pfa.piloter-ranking');
        break;
      case 'pilotagefideliteofficine':
        requiredRoles.push('pfa.piloter-fidelite-officine');
        break;
      case 'pilotagefideliteclient':
        requiredRoles.push('pfa.piloter-fidelite-client');
        break;
      case 'pilotagepricing':
        requiredRoles.push('pfa.piloter-pricing');
        break;
      case 'suivilabo':
        requiredRoles.push('pfa.piloter-suivi-labo');
        break;
      case 'operateurs':
        requiredRoles.push('pfa.piloter-operateurs');
        break;
      case 'trade':
        requiredRoles.push('pfa.piloter-trade');
        break;
      case 'simulation-generique':
        requiredRoles.push('pfa.remise-generique', 'pfa-gpo.remise-generique');
        break;
      case 'simulation-grossiste':
        requiredRoles.push('pfa.remise-grossiste', 'pfa-gpo.remise-grossiste');
        break;
      case 'promotion':
        requiredRoles.push('pfa.piloter-promotion');
        break;
      case 'mex':
        requiredRoles.push('pfa.piloter-mex');
        break;
      case 'gestioncomptes':
        requiredRoles.push(
          'pfa.administrer-gestion-comptes',
          'pfa-gpo.administrer-gestion-comptes',
        );
        break;
      case 'gestionautorisations':
        requiredRoles.push('pfa-gpo.administrer-autorisations');
        break;
      case 'pilotageservicedesante':
        requiredRoles.push('pfa.piloter-service-sante');
        break;
      case 'biosimilaires':
        requiredRoles.push('pfa.piloter-biosimilaires');
        break;
      case 'generiques':
        requiredRoles.push('pfa.piloter-generiques');
        break;
      case 'pilotageaccordscommerciaux':
        requiredRoles.push('pfa.pilotage-accords-commerciaux');
        break;
    }

    if (this.authenticated) {
      const userRoles: string[] = this.keycloak.getUserRoles();
      const hasRequiredRoles = requiredRoles.some(role => userRoles.includes(role));
      if (!hasRequiredRoles) {
        return this.router.parseUrl('/forbidden');
      }
    } else {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
    }

    return this.authenticated;
  }
}
